import React, { useRef, useState, useEffect } from 'react'
import { Dropdown, Form, InputGroup } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import DropDownControl from '../../components/DropDownControl'
import requestApi from '../../utils/request'
import { useMutation, useQuery } from 'react-query'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { jobopeningmanagement, blogs } from "../../Routes/routingConsts";
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import InputControl from '../../components/InputControl'
// import { '', '' } from '../../Routes/routingConsts'
import { ReactComponent as Cross } from '../../assets/images/cross.svg'
import { ReactComponent as SearchblackIcon } from '../../assets/images/search.svg'
import { experienceLists } from '../../functions/common'
import Swal from 'sweetalert2'
import { ReactComponent as BackIcon } from '../../assets/images/left-arrow.svg'
import ButtonWithLoader from '../../components/ButtonWithLoader/ButtonWithLoader'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import ckeditor, { CKEditor } from '@ckeditor/ckeditor5-react'
import Select, { components, OptionProps } from 'react-select'
import { getFormData } from '../../functions/common'
import { Spinner } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import ReactPlayer from 'react-player'
import { ReactComponent as SelectImg } from '../../assets/images/selectimg.svg'
import DropDownControlForCategery from '../../components/DropDownControlForCategery/DropDownControlForCategery'
const getlocation = (datalist) => {
    return requestApi
        .post(`/user-home/location`, { search: datalist })
        .then((res) => {
            return res.data
        })
}

const fetchQuery = (query) => {
    return requestApi
        .post(`/user-home/job-skill`, {
            search: query
        })
        .then((res) => {
            return res.data
        })
}
export async function addnewSkill(skillname) {
    return await requestApi.post('/employer/new-add-skill', {
        name: skillname
        // temp_skill: true
    })
}

const ViewBlog = () => {
    const createJobOpeningvalidation = yup.object({
        blogTitle: yup.string().trim().required('Please enter blog Title.'),
        conclusion: yup.string().trim().required('Please enter conclusion.'),
        description: yup
            .string()
            .trim()
            .required('Please enter blog description'),
    })
    const [show, setShow] = useState(false)
    const { blogId } = useParams()

    const { state } = useLocation()

    const navigate = useNavigate()

    const {
        control,
        register,
        watch,
        clearErrors,
        handleSubmit,
        reset,
        setError,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(createJobOpeningvalidation),
    })
    const { Option } = components
    const [editorState, setEditorState] = useState()
    const [countryId, setCountryId] = useState(null)
    const skillField = useRef(null)
    const locationField = useRef(null)
    const industryField = useRef(null)
    const [userSkills, setuserSkills] = useState([])
    const [toggleForSkill, setToggleForSkill] = useState(false)
    const [skill, setSkill] = useState('')
    const [changeDataLocation, setChangeDataLoaction] = useState('')
    const [toggleForLocation, setToggleForLocation] = useState(false)
    const [toggleForIndustry, setToggleForIndustry] = useState(false)
    const [ckeditordata, setckeditordata] = useState('')
    const handleCancleButton = () => {
        if (state === 'dashBoardJobOpening') {
            navigate('')
        } else {
            navigate('')
        }
    }
    const IconOption = (props) => {
        const { label, industryName } = props.data

        return (
            <Option {...props}>
                <div className="react-select-option">{industryName}</div>
            </Option>
        )
    }
    const onEditorStateChange = (e) => {
        setEditorState(e)
    }
    const handleClose = () => {
        setShow(false)
        skillreset()
        setSkill('')
    }
    const addnewmutation = useMutation(addnewSkill, {
        onSuccess: ({ data }) => {
            setValue('keywords', [
                ...userSkills,
                { name: data?.data?.name, _id: data?.data?._id }
            ])
            setuserSkills((prev) => {
                return [
                    ...prev,
                    { name: data?.data?.name, _id: data?.data?._id }
                ]
            })

            handleClose()
            if (userSkills.length === 0) {
                clearErrors('keywords')
            }

            // addmutation.mutate(data?.data?._id)
            // setsearchedVal('')
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })
    const [tagData, setTagData] = useState([]);
    console.log(tagData, 'tagData')
    const handleOnSubmit = (data) => {
        setTagData((prevTagData) => [...prevTagData, data.tags]);
        handleClose();
      };
    const { data: country, isLoading: countryLoading } = useQuery({
        queryKey: ['country', changeDataLocation],
        queryFn: () => getlocation(changeDataLocation),
        enabled: !!changeDataLocation,
        onSuccess: (data) => {}
    })

    const mySkillValidation = yup.object({
        tags: yup
            .string()
            .trim()
            .max(25, 'Must be at max 25 characters')
            .required('Please enter tag')
    })
    const {
        register: skillregister,
        reset: skillreset,
        setError: skilsetError,
        setValue: skillsetValue,
        clearErrors: skillclearErrors,
        handleSubmit: skillhandleSubmit,
        formState: { errors: skillerrors }
    } = useForm({ resolver: yupResolver(mySkillValidation) })
    async function getachivedDetail({ queryKey }) {
        return await requestApi
            .post(
                `/job-opening/view`,
                { blogId: state },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }

    const {
        data: getAcrchived,
        isLoading: viewOnCopy,
        isFetching
    } = useQuery({
        queryKey: ['Archived'],
        queryFn: getachivedDetail,
        enabled: !!state,
        onSuccess: (data) => {
            reset({
                jobTitle: data.data.jobTitle,
                // industry: data.data.industry,

                industry: {
                    industryId: data?.data?.industry,
                    industryName: data?.data?.industryName
                },
                // location: {
                //     cityId: data?.data?.cityId,
                //     location: data?.data?.location
                // }
                location: {
                    cityId: data?.data?.locationId,
                    location: data?.data?.location
                },
                // location: data.data.location,
                experience:
                    data.data.experience > 1
                        ? `${data.data.experience} Years`
                        : `${data.data.experience} Year`,
                jobType: data.data.jobType,
                // salary: data.data.salary,
                totalOpening: data.data.totalOpening,
                jobStatus: data.data.jobStatus,
                locationType: data.data.locationType,
                keySkill: data.data.keySkill,
                jobDescription: data.data.jobDescription,
                isSalarySpecified: !data?.data?.isSalarySpecified,
                currency: data?.data?.currency ?? '',
                maxSalary: data?.data?.maxSalary ?? null,
                minSalary: data?.data?.minSalary ?? null,
                salaryType: data?.data?.salaryType ?? ''
            })

            setckeditordata(data.data.jobDescription)

            // locationField.current.value = 'data.data.location'
            setuserSkills(
                data.data.keySkill.split(',').map((e) => {
                    return { name: e }
                })
            )
            setValue(
                'keywords',
                data.data.keySkill.split(',').map((e) => {
                    return { name: e }
                })
            )
        }
    })

    //list category API

    async function categoryList() {
        return await requestApi.post(
            `category/list`,
            { limit: 550 },
            { headers: true }
        )
    }
    const { data: categoryDataList } = useQuery({
        queryKey: ['category'],
        queryFn: () => categoryList('country')
        // enabled: !!userProfile
    })

    // console.log(categoryDataList?.data?.data, 'categoryDataList');

    const deleteSkill = (id) => {
        setuserSkills((prev) => prev.filter((skill) => skill?._id !== id))
        if (userSkills.length === 1) {
            setError('keywords', 'Please Select Keywords')
        }
    }
    const { data: jobSkills } = useQuery({
        queryKey: ['jobSkill', skill],
        queryFn: () => fetchQuery(skill),
        enabled: !!skill,
        onSuccess: (data) => {}
    })

    let timmer
    const handleChangeSkill = (e) => {
        if (timmer) {
            clearTimeout(timmer)
        }
        timmer = setTimeout(() => {
            setSkill(e.target.value)
        }, 400)
    }

    //////// add-edit api for new opening job //////
    // const statelocation = useLocation()
    async function newAddJobOpening(payload) {
        if (blogId) {
            // let industryName = industry
            return await requestApi
                .post(
                    `blog/add-edit`,
                    payload
                )
                .then((res) => {
                    return res.data
                })
        } else {
            // let locationName = JSON.parse(location)
            // let industryName = industry
            return await requestApi
                .post(
                    `blog/add-edit`,
                    payload
                )
                .then((res) => {
                    return res.data
                })
        }
    }
    const mutation = useMutation(newAddJobOpening, {
        onSuccess: (data) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                allowOutsideClick: false,
                text: data?.meta?.message
            }).then(() => {
                navigate(blogs)
            })
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })
    //Start Drop down for location////
    const IconOptionLocation = (props) => {
        const { label, location } = props.data

        return (
            <Option {...props}>
                <div className="react-select-option">{location}</div>
            </Option>
        )
    }

    const [userLocation, setUserlocation] = useState([])
    const [searchDeatails, setSearchDeatails] = useState({
        location: ''
    })

    let locationTimmer
    const handleChangeLocation = (e) => {
        if (locationTimmer) {
            clearTimeout(locationTimmer)
        }
        locationTimmer = setTimeout(() => {
            setChangeDataLoaction(e)
            // setChangeDataLoaction(e.target.value)
        }, 400)
    }
    function handleDropDown(fieldValue, fieldName) {
        setUserlocation((prev) => {
            return { ...prev, [fieldName]: JSON.parse(fieldValue) }
        })
    }
    const addLocationData = (selectedSkill, fieldValue, fieldName) => {
        setUserlocation((prev) => {
            return { ...prev, [fieldName]: fieldValue }
        })
        locationField.current.value = ''
    }
    // end Drop Down for location///

    // industry search dropDown /////
    const [userIndustry, setUserIndustry] = useState([])
    const [changeDataIndustry, setChangeDataIndustry] = useState('')

    let industryTimmer
    const handleChangeIndustry = (e) => {
        if (industryTimmer) {
            clearTimeout(industryTimmer)
        }
        industryTimmer = setTimeout(() => {
            setChangeDataIndustry(e.target.value)
        }, 400)
    }

    const addIndustryData = (selectedSkill, fieldValue, fieldName) => {
        setUserIndustry((prev) => {
            return { ...prev, [fieldName]: fieldValue }
        })
        industryField.current.value = ''
    }

    // end industry drop-down /////

    ///////// view api for data ////
    const [viewBlogData, setViewBlogData] = useState(null);
    console.log('viewBlogData',viewBlogData)
    async function viewJobOpeningData(jobOpening) {
        return await requestApi
            .post(
                `/blog/view`,
                { blogId: jobOpening },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }

    const [imgType, setImgType] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['view-job-profile'],
        queryFn: () => viewJobOpeningData(blogId),
        enabled: !!blogId,
        onSuccess: (data) => {
            // const blocksFromHTML = htmlToDraft(data.data.jobDescription)
            // setEditorState(
            //     EditorState.createWithContent(
            //         customContentStateConverter(
            //             ContentState.createFromBlockArray(
            //                 blocksFromHTML.contentBlocks,
            //                 blocksFromHTML.entityMap
            //             )
            //         )
            //     )
            // )
            setViewBlogData(data?.data)
            setImgType(data?.data?.image)
            console.log(data?.data, 'imgaaaaa')
            reset({
                blogTitle: data?.data?.blogTitle,
                conclusion: data?.data?.conclusion,
                description: data?.data?.description,
            })
            setImageUrl(data?.data?.image)
            setTagData(data?.data?.tags)
            setValue('profilePic', data?.data?.image)
            console.log(data.data, 'datadata')
           


            // locationField.current.value = data.data.location
            // setuserSkills(
            //     data.data.keySkill.split(',').map((e) => {
            //         return { name: e }
            //     })
            // )
            // setValue(
            //     'keywords',
            //     data.data.keySkill.split(',').map((e) => {
            //         return { name: e }
            //     })
            // )
        }
    })
    //////////// end view /////
    //////
    const addSkill = (selectedSkill) => {
        setuserSkills((prev) => {
            if (
                prev.some((p) => {
                    return p._id === selectedSkill?._id
                })
            ) {
                setValue('keywords', prev)
                return prev
            } else {
                setValue('keywords', [...prev, selectedSkill])
                return [...prev, selectedSkill]
            }
        })

        skillField.current.value = ''
    }
    const customContentStateConverter = (contentState) => {
        // changes block type of images to 'atomic'
        const newBlockMap = contentState.getBlockMap().map((block) => {
            const entityKey = block.getEntityAt(0)
            if (entityKey !== null) {
                const entityBlock = contentState.getEntity(entityKey)
                const entityType = entityBlock.getType()
                switch (entityType) {
                    case 'IMAGE': {
                        const newBlock = block.merge({
                            type: 'atomic',
                            text: 'img'
                        })
                        return newBlock
                    }
                    default:
                        return block
                }
            }
            return block
        })
        const newContentState = contentState.set('blockMap', newBlockMap)
        return newContentState
    }

    function handleCKEditor(event, editor) {
        const data = editor.getData()

        setckeditordata(data)
    }

    const handleDeleteTag = (index) => {
        const arr = [...tagData];
        const removedvalue = arr.splice(index, 1);
        setTagData([...arr]);
    }

    const uploadImage = useRef(null)
    const [imageUrl, setImageUrl] = useState(null)
    const [imageErr,setimageErr] = useState('')

    console.log('imageUrl',imageUrl)
    console.log('imageErr',imageErr)

    const handleFileUpload = (e) => {  
        if (
            e.target.files[0].type === 'image/jpg' ||
            e.target.files[0].type === 'image/jpeg' ||
            e.target.files[0].type === 'image/png'
        ) {
            setValue('profilePic', e.target.files[0])
            setImageUrl(URL.createObjectURL(e.target.files[0]))   
            setimageErr('')
        } else {
            setimageErr('Please select .jpeg, .jpg or .png file formate.')
        }
    }

    const [submitValidation, setSubmitValidation] = useState(false);
    const onSubmit = (data) => {
    
        console.log('data1111111111111111111',data)
        if(imageUrl !== null){
            const payload = {
                description: data.description,
                blogTitle: data.blogTitle,
                tags: tagData,
                conclusion: data.conclusion,
                blogImage: data.profilePic
            }
            // if (typeof data.profilePic ==="object") {
            //     payload.blogImage=data.profilePic
            // }
            if (blogId) {
                payload.blogId= blogId
             }
             const formdata = getFormData(payload)
             mutation.mutate(formdata)
            console.log(data, 'data')
           
        }
    }
    const colourStyles = {
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            // const color = chroma(data.color);
            return {
                ...styles,
                backgroundColor: isFocused ? '#002a3a' : null,
                color: isFocused ? 'white' : 'black',
                ':active': {
                    backgroundColor: '#002a3a'
                }
            }
        }
    }
// console.log(errors)
    return (
        <div className="sidebar-content common-page view-blog">
            {viewOnCopy || isFetching ? (
                <div className="spinner-wrapper">
                    <Spinner animation="border" role="status" className="tdata">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            ) : (
                <>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <div className="whitebox">
                            <div className="previous-page-icon" style={{padding: '10px 20px 0px'}}>
                                <Link to={blogs}>
                                    <span className="back-btn" style={{margin: '0px'}}>
                                        <BackIcon className="back-icon" style={{transform: 'rotate(0deg)'}} />
                                        Back
                                    </span>
                                </Link>
                            </div>
                            <div className="createnew-box">
                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <p>{viewBlogData?.blogTitle}</p>
                                    </div>

                                    <div className="col-12">
                                        <div className='tag-area' style={{padding: '0px'}}>
                                                {viewBlogData?.tags?.map((item, index) => (
                                                <p className='tag-item' key={index}>{item}</p>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="whitebox">
                            <div className="" style={{padding: '25px'}}>
                                <img src={viewBlogData?.image} alt="" style={{width: '100%', maxHeight: '600px', objectFit: 'cover'}} />
                            </div>
                        </div>

                        {viewBlogData?.videoUrl !== '' && <div className="whitebox">
                            <div className="" style={{padding: '25px'}}>
                                {/* <iframe width="100%" height="445" src={viewBlogData?.videoUrl}></iframe> */}
                                <ReactPlayer url={viewBlogData?.videoUrl} width="100%" height="500px" />
                            </div>
                        </div>}

                        <div className="whitebox">
                            <div className="title-text">
                                <h3>Description</h3>
                            </div>
                            <div className="dec" style={{padding: '25px'}}>
                                <div dangerouslySetInnerHTML={{__html:viewBlogData?.description}}></div>
                            </div>
                        </div>

                        <div className='whitebox'>
                            <div className="title-text">
                                <h3>Conclusion</h3>
                            </div>
                           <div className='conclusion' style={{padding: '25px'}}>
                                <p>{viewBlogData?.conclusion}</p>
                           </div>
                        </div>
                    </Form>
                </>
            )}
            <Modal
                className="modalbox"
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <div className="modal-title">
                        <h3>Add Tag</h3>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        className="row"
                        onSubmit={skillhandleSubmit(handleOnSubmit)}
                    >
                        <div className="col-12">
                            <InputControl
                                label="Tag Name"
                                name="tags"
                                register={skillregister}
                                error={skillerrors.tags?.message}
                                autoComplete="off"
                            />
                        </div>

                        <div className=" col-12">
                            <div className="save">
                                <ButtonWithLoader
                                    isLoading={addnewmutation?.isLoading}
                                    cssClass="common-btn"
                                >
                                <button
                                    className="common-btn"
                                    type="submit"
                                >
                                    Save
                                </button>
                                </ButtonWithLoader>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ViewBlog;
